import { EquipmentModel } from '../../shared/model/equipment-model';
import { ProvidedService } from '../../shared/model/provided-service';

export class Screening {
  constructor(public id?,
              public configurationType?,
              public gpsStatus?,
              public gprsStatus?,
              public smsStatus?,
              public lineStatus?,
              public creationDate?,
              public canEdit?,
              public canView?,
              public lastUpdateDate?,
              public accessoryAmounts?,
              public equipmentModel?: EquipmentModel,
              public providedServices?: Array<ProvidedService>,
              public isEditable?,
              public isVisible?,
              public argosUser?,
              public editable?,
              public observation?,
              public associateAutoeletric?: any) {}
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/screening.ts